import React, { FC, ReactNode } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { SeoLink } from 'dibs-seo/exports/SeoLink';
import ResponsiveImage from '../ResponsiveImage';
import HpLazyImageWrapper from '../HpLazyImageWrapper/HpLazyImageWrapper';
import classnames from 'classnames';

import styles from './HpRespModuleItemTile.scss';

import { HpRespModuleItemTile_linkData } from './__generated__/HpRespModuleItemTile_linkData.graphql';

type Props = {
    linkData: HpRespModuleItemTile_linkData | null;
    dataTn: string;
    imageUrl?: string | null;
    imageWidth?: string | null;
    imageHeight?: string | null;
    onClick?: () => void;
    title?: string | null;
    description?: string | null;
    cta?: string | null;
    imgSizes?: string;
    imgSrcSetWidths?: number[];
    imgOverlayContent?: ReactNode;
    textClass?: string;
    imageClass?: string;
    imageOverlayClass?: string;
    useLazyLoadImages: boolean;
};

const HpRespModuleItemTile: FC<Props> = ({
    title,
    description,
    cta,
    linkData,
    imageUrl,
    imageHeight,
    imageWidth,
    dataTn,
    onClick = () => {},
    imgSizes,
    imgSrcSetWidths,
    imgOverlayContent,
    textClass,
    imageClass,
    imageOverlayClass,
    useLazyLoadImages,
}) => {
    const linkContent = (
        <>
            <div className={classnames(styles.imageOverlay, imageOverlayClass)}>
                <HpLazyImageWrapper
                    useLazyLoad={useLazyLoadImages}
                    imageHeight={imageHeight}
                    imageWidth={imageWidth}
                >
                    <ResponsiveImage
                        // no need for alt if title is present bc labeling the img with title is
                        // redundant with title as link text. only use alt if != title.
                        ariaHidden
                        className={classnames(imageClass, styles.image)}
                        src={imageUrl || ''}
                        sizes={imgSizes}
                        srcSetWidths={imgSrcSetWidths}
                    />
                </HpLazyImageWrapper>
                {imgOverlayContent}
            </div>
            <div className={classnames(styles.text, textClass)}>
                {title && <div className={styles.header}>{title}</div>}
                {description && <div className={styles.description}>{description}</div>}
                {cta && <div className={styles.cta}>{cta}</div>}
            </div>
        </>
    );

    return linkData ? (
        <SeoLink linkData={linkData} className={styles.link} dataTn={dataTn} onClick={onClick}>
            {linkContent}
        </SeoLink>
    ) : (
        linkContent
    );
};

export default createFragmentContainer(HpRespModuleItemTile, {
    linkData: graphql`
        fragment HpRespModuleItemTile_linkData on LinkData {
            ...SeoLink_linkData
        }
    `,
});
